"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenHeight = exports.getScreenWidth = exports.getBottomInsetHeight = exports.getAppBarHeight = exports.getNavBarHeight = exports.getStatusBarHeight = exports.getRawStatusBarHeight = exports.isIphoneX = void 0;
const react_native_1 = require("react-native");
const platform_1 = require("./platform");
const NAVIGATION_BAR_IOS = 44;
const STATUS_BAR_HEIGHT_X = 44;
const STATUS_BAR_HEIGHT_12 = 47;
const STATUS_BAR_HEIGHT_14_PRO = 59;
const STATUS_BAR_HEIGHT_16_PRO = 59;
const STATUS_BAR_HEIGHT_IOS_DEFAULT = 20;
function getSizeByDevice(device) {
    switch (device) {
        case 'x':
            return { width: 375, height: 812 };
        case 'xs-max':
            return { width: 414, height: 896 };
        case '12':
            return { width: 390, height: 844 };
        case '12-max':
            return { width: 428, height: 926 };
        case '14-pro':
            return { width: 393, height: 852 };
        case '14-pro-max':
            return { width: 430, height: 932 };
        case '16-pro':
            return { width: 402, height: 874 };
        case '16-pro-max':
            return { width: 440, height: 956 };
        default:
            if (__DEV__)
                throw new Error(`${device} is not supported`);
            return { width: 0, height: 0 };
    }
}
function getScreenWidth() {
    return react_native_1.Dimensions.get('window').width;
}
exports.getScreenWidth = getScreenWidth;
function getScreenHeight() {
    return react_native_1.Dimensions.get('window').height;
}
exports.getScreenHeight = getScreenHeight;
/** iOS device checker helper based on screen size */
function checkIOSDevice(device) {
    if (react_native_1.Platform.OS === 'ios' && !react_native_1.Platform.isPad && !react_native_1.Platform.isTVOS) {
        const size = getSizeByDevice(device);
        return ((getScreenWidth() === size.width && getScreenHeight() === size.height) || // portrait
            (getScreenWidth() === size.height && getScreenHeight() === size.width) // landscape
        );
    }
    return false;
}
function isIphoneX() {
    return (checkIOSDevice('x') ||
        checkIOSDevice('xs-max') ||
        checkIOSDevice('12') ||
        checkIOSDevice('12-max') ||
        checkIOSDevice('14-pro') ||
        checkIOSDevice('14-pro-max') ||
        checkIOSDevice('16-pro') ||
        checkIOSDevice('16-pro-max'));
}
exports.isIphoneX = isIphoneX;
/**
 * Get the real value of status bar height
 * @see https://github.com/ovr/react-native-status-bar-height/blob/0357fd677a80d3d7a092bda8aab913e7671728ea/index.js#L17
 */
function getRawStatusBarHeight() {
    var _a;
    function getIOSRawStatusBarHeight() {
        if (checkIOSDevice('x') || checkIOSDevice('xs-max'))
            return STATUS_BAR_HEIGHT_X;
        if (checkIOSDevice('12') || checkIOSDevice('12-max'))
            return STATUS_BAR_HEIGHT_12;
        if (checkIOSDevice('14-pro') || checkIOSDevice('14-pro-max'))
            return STATUS_BAR_HEIGHT_14_PRO;
        if (checkIOSDevice('16-pro') || checkIOSDevice('16-pro-max'))
            return STATUS_BAR_HEIGHT_16_PRO;
        return STATUS_BAR_HEIGHT_IOS_DEFAULT;
    }
    if (react_native_1.Platform.OS === 'ios')
        return getIOSRawStatusBarHeight();
    if (react_native_1.Platform.OS === 'android')
        return (_a = react_native_1.StatusBar.currentHeight) !== null && _a !== void 0 ? _a : 0;
    return 0;
}
exports.getRawStatusBarHeight = getRawStatusBarHeight;
/**
 * Get status bar height with android UI assigned to 0
 * This is useful for managing View to start under StatusBar
 */
function getStatusBarHeight() {
    return (0, platform_1.isAndroidUI)() ? 0 : getRawStatusBarHeight();
}
exports.getStatusBarHeight = getStatusBarHeight;
/**
 * Get navigation bar height depending on platform
 * @see https://github.com/react-navigation/react-navigation-stack/blob/f3f6191286822603fcf238a065e0088ec576a776/src/views/Header/Header.js#L20
 */
function getNavBarHeight() {
    if ((0, platform_1.isiOS)()) {
        return NAVIGATION_BAR_IOS;
    }
    return 56;
}
exports.getNavBarHeight = getNavBarHeight;
/**
 * Get app bar height depending on platform (navbar height + statusbar height)
 * @see https://github.com/react-navigation/react-navigation-stack/blob/f3f6191286822603fcf238a065e0088ec576a776/src/views/Header/Header.js#L73
 */
function getAppBarHeight() {
    return getNavBarHeight() + getStatusBarHeight();
}
exports.getAppBarHeight = getAppBarHeight;
/**
 * Get bottom inset height depending on platform
 * @see https://github.com/react-native-community/react-native-safe-area-view/blob/5000a8af587e8fe4f1068a1e81edb5b6f4f5da33/index.js#L342
 */
function getBottomInsetHeight() {
    return isIphoneX() ? 34 : 0;
}
exports.getBottomInsetHeight = getBottomInsetHeight;
